import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import { banners } from 'services/selectors/exclusivity-banner';
import { SANTANDER_LINK } from 'constants/Constants';
import cobrandSantander from 'assets/cobrand-Santander.svg';
import cartMini from 'assets/cart-mini.svg';

const ExclusivitySantander = ({ uui, removeFunc }) => {
  const banner = useSelector(banners);
  const results = banner !== undefined ? banner.results : {};
  const history = useHistory();

  const removeExp = () => {
    removeFunc(uui);
    history.push('/');
  };

  return (
    <>
      <Col lg={9} className="text-center">
        <h2>¡Lo sentimos, no se pudo completar el pedido!</h2>
        <h3 className="pt-30 text-tangaroa">
          La Experiencia que intentaste adquirir es exclusiva de
          Tarjetahabientes Santander
        </h3>
        <h3 className="pb-30 text-tangaroa">
          Aeroméxico. Si deseas adquirir La Tarjeta da
          {' '}
          <a href={SANTANDER_LINK}>click aquí</a>
        </h3>
        <img src={cobrandSantander} alt="shopping-cart-cobrand-santander" />
        <h3 className="py-30 text-boulder-light">
          Haz clic en el botón de ‘Navegar’ para buscar más Experiencias.
        </h3>
        <button type="button" className="btn btn-primary" onClick={removeExp}>
          Navegar
        </button>
      </Col>
      <Col lg={3}>
        <div className="bg-color-alabaster p-15 mt-30 mt-lg-0">
          <div className="overlap-gray">
            <img src={cartMini} alt="shopping-cart-icon" className="py-15" />
            <h3>Resumen de tu pedido</h3>
            <p>Aún no tienes seleccionado ningún campo</p>
          </div>
        </div>
        <div className="my-15 position-relative">
          <div className="text-center">
            <a href={results.buttonLink} className="btn btn-primary btn-absolute-bottom">
              { results.buttonText }
            </a>
          </div>
          <img
            src={results.image}
            alt="promo"
            width="100%" />
        </div>
      </Col>
    </>
  );
};

ExclusivitySantander.propTypes = {
  uui: PropTypes.number.isRequired,
  removeFunc: PropTypes.func.isRequired,
};

export default ExclusivitySantander;
